<template>
  <div class="tw-mb-6" :data-testid="'c_' + selectedCompany.id">
    <div
      class="
        sf-level sf-level-between sf-layer-border sf-layer-rounded sf-pad-2
      "
    >
      <ExternalCompanyLabel
        :company-id="selectedCompany.id"
        :company-name="selectedCompany.name"
        :last-synced-at="selectedCompany.lastSyncedAt"
        :ledger-label="ledgerLabel"
        :show-selected-label="true"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ExternalCompany } from '@app/application/company_links/types'
import ExternalCompanyLabel from '@app/application/company_links/components/external-company-label.vue'

interface Props {
  ledgerLabel: string
  selectedCompany: ExternalCompany
}

const { ledgerLabel, selectedCompany } = defineProps<Props>()
</script>
